import React from "react";
import "./style.css";

const Page404 = () => {
    return (
        <div className="page-404-container">
            <img src={require("../../assets/img/404.png")} />
            <pre className="page-404-titulo">Página não encontrada</pre>
        </div>
    )
}

export default Page404;